/**
 * [G-4 SHOULD, QA voz v3, 08/09] "falha do STT (500) deixa a sessão de voz
 * ativa sem microfone e sem saída óbvia" — falha de transcrição (rede/500)
 * na parada AUTOMÁTICA (VAD, `manual: false`) do Modo de Voz nunca pode
 * deixar a sessão viva sem escuta. 1ª falha CONSECUTIVA reabre o mic
 * sozinho, com um aviso que diz a próxima ação; a 2ª desiste, encerra a
 * sessão e avisa — devolvendo o composer ao estado normal.
 *
 * Extraído de `motor-de-voz.js` pra manter o arquivo sob o teto de 500
 * linhas do projeto. Estado (contador) fica aqui; os efeitos colaterais
 * (avisar o destino, reabrir o mic, encerrar a sessão) são injetados por
 * quem monta — mesmo racional de `barge-in-de-voz.js`/`fala-da-ia.js`,
 * evita import circular com `motor-de-voz.js`.
 */
export const LIMITE_FALHAS_STT_CONSECUTIVAS = 2
export const MENSAGEM_FALHA_STT_RETRY =
  'Não consegui ouvir. Fale de novo ou saia do modo de voz.'
export const MENSAGEM_FALHA_STT_DESISTIR =
  'Não consegui ouvir de novo. Saindo do Modo de Voz — pode digitar normalmente.'

/**
 * @param {Object} deps
 * @param {(mensagem: string) => void} deps.avisar - mostra o feedback no destino atual
 * @param {() => void} deps.reabrir - reabre o mic (mesmo caminho do `sem_fala`)
 * @param {() => void} deps.desistir - encerra a sessão de voz
 * @param {() => boolean} deps.podeReabrir - guarda: sessão ainda ativa e há avisos pra reusar
 */
export const criarControleDeFalhaDeStt = ({ avisar, reabrir, desistir, podeReabrir }) => {
  let falhasConsecutivas = 0

  const resetar = () => {
    falhasConsecutivas = 0
  }

  const registrarFalha = () => {
    falhasConsecutivas += 1
    if (falhasConsecutivas < LIMITE_FALHAS_STT_CONSECUTIVAS && podeReabrir()) {
      avisar(MENSAGEM_FALHA_STT_RETRY)
      reabrir()
      return
    }
    falhasConsecutivas = 0
    desistir()
    avisar(MENSAGEM_FALHA_STT_DESISTIR)
  }

  return { registrarFalha, resetar }
}
